module.exports = __webpack_public_path__ + "img/routing_number.4820be78.jpg";